/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_VoucherInputs */

const en_pricing_voucher = /** @type {(inputs: Pricing_VoucherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a voucher code?`)
};

const id_pricing_voucher = /** @type {(inputs: Pricing_VoucherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punya kode voucher?`)
};

/**
* | output |
* | --- |
* | "Have a voucher code?" |
*
* @param {Pricing_VoucherInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_voucher = /** @type {((inputs?: Pricing_VoucherInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_VoucherInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_voucher(inputs)
	return en_pricing_voucher(inputs)
});